import { Alert, Card, Form, Input } from 'antd';
import { CreateLayout } from 'components/layout/layout/CreateLayout';
import { IPersonification } from 'interfaces/personifications';
import { PageHeader } from 'components/professor_area/PageHeader';
import { TeamOutlined } from '@ant-design/icons';
import { getTenant } from 'services/tenants';
import { useEffect, useState } from 'react';
import { useForm } from '@refinedev/antd';

export const PersonificationCreate = () => {
  const { formProps, saveButtonProps, mutationResult } =
    useForm<IPersonification>();

  const [showInfo, setShowInfo] = useState(false);
  const [description, setDescription] = useState('');
  const [message, setMessage] = useState('');

  const { lmsUrl } = getTenant();

  const handleFinish = (values: Record<string, unknown>) => {
    const email = ((values?.email as string) ?? '')?.trim();

    return formProps.onFinish?.({
      ...values,
      email
    });
  };

  useEffect(() => {
    if (mutationResult.data) {
      setShowInfo(true);

      const { token, user } = mutationResult.data.data;
      setDescription(`Você será redirecionado para ${lmsUrl}`);
      setMessage(`Personificando ${user.name} (${user.email})`);
      const url = new URL(`${lmsUrl}/personificar`);

      url.search = new URLSearchParams({ token }).toString();
      setTimeout(() => {
        setShowInfo(false);
        window.open(url, '_blank');
      }, 4000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mutationResult.data]);

  return (
    <CreateLayout
      saveButtonProps={saveButtonProps}
      title="Criar simulação de aluno"
    >
      <PageHeader title="Criar simulação de aluno" icon={TeamOutlined} />

      <Card>
        <Form {...formProps} layout="vertical" onFinish={handleFinish}>
          <Form.Item
            label="Email do aluno"
            name="email"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Card>

      {showInfo && (
        <Alert message={message} description={description} type="info" />
      )}
    </CreateLayout>
  );
};
